import {NextPage} from 'next';
import Head from 'next/head';
import {ArrowRightIcon} from '@heroicons/react/20/solid';

import {InteractivePlayer} from '@/components/player-v2/InteractivePlayer';
import {useInteractiveSceneV2Config} from '@/components/player-v2/InteractiveSceneV2/useInteractiveSceneV2Config';
import {SeekToTimelineElement} from '@/components/player-v2/TimelineElement/SeekToTimelineElement';
import {WR_INTERACTIVE_SCENES_2} from '@/components/player-v2/InteractiveVoting/WhiteRabbitInteractiveScenesConfig';

const EPISODE_SIX_SEVEN_METADATA = {
  video_url:
    'https://stream.mux.com/PkFI5GaMxSca9YL7ABnrmDNPnONZRcDuveARk5kON004.m3u8',
};

const WhiteRabbitFinalPlayerPage: NextPage = () => {
  const interactiveSceneV2Config = useInteractiveSceneV2Config({
    isCh6: true,
  });

  const timelineElems = [
    {
      element: (
        <SeekToTimelineElement
          key="seek"
          icon={<ArrowRightIcon className="h-5 w-5" />}
          iconPosition="right"
          seekToSeconds={1223}
          text="Skip to chapter 6"
        />
      ),
      startSecond: 10,
      endSecond: 15,
    },
  ];

  return (
    <>
      <Head>
        <title>White Rabbit Chapter 6 & 7</title>
        <meta name="description" content="White Rabbit" />
      </Head>

      <InteractivePlayer
        backButtonBehavior={{
          type: 'goBack',
          fallbackHref: '/shows/white-rabbit',
        }}
        metadata={{
          projectId: 'white-rabbit',
          title: 'White Rabbit',
          subtitle: `Chapter 6 & 7`,
        }}
        url={EPISODE_SIX_SEVEN_METADATA.video_url}
        interactionConfig={{
          supportedInteractions: ['dialogue', 'scene'],
          interactiveScenes: WR_INTERACTIVE_SCENES_2,
          interactiveSceneV2: interactiveSceneV2Config,
        }}
        controls={{
          hasControls: true,
        }}
        timelineElements={timelineElems}
      />
    </>
  );
};

export default WhiteRabbitFinalPlayerPage;
